import React from 'react';
import Header from '../../components/reusable/Header.jsx';
import BackButton from '../../components/reusable/buttons/BackButton.jsx';
import PageTitle from '../../components/reusable/PageTitle.jsx';

const TermsAndConditions = () => {
    return (
        <div className='px-4 max-w-4xl mx-auto'>
            <Header>
                <BackButton from='' />
            </Header>
            <PageTitle>
                <div className='text-[20px] uppercase'>
                    TERMS AND CONDITIONS
                </div>
            </PageTitle>

            <p className='text-sm mb-4'>Last updated: 16/09/2024</p>

            <section className='mb-6'>
                <p>
                    Welcome to PLAYER, a platform operated by PLAYERAPP LTD. By
                    accessing or using the PLAYER website, mobile app, or
                    services (collectively, the “Platform”), you agree to comply
                    with and be bound by these Terms and Conditions. Please read
                    them carefully before using the Platform.
                </p>
                <p>
                    If you do not agree to these Terms and Conditions, you must
                    not use the Platform.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>1. Definitions</h3>
                <ul className='list-disc list-inside'>
                    <li>
                        <strong>Platform:</strong> refers to the PLAYER website,
                        mobile apps, and associated services.
                    </li>
                    <li>
                        <strong>User:</strong> refers to any individual who
                        registers or interacts with the Platform, including
                        football players, scouts, coaches, agents, and other
                        visitors.
                    </li>
                    <li>
                        <strong>Content:</strong> refers to any material (such
                        as photos, videos, text, or data) that users upload to
                        or share via the Platform.
                    </li>
                </ul>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>2. Eligibility</h3>
                <p>
                    PLAYER is intended for users aged 16 years and older. By
                    using the Platform, you represent and warrant that you are
                    at least 16 years of age. We do not knowingly collect or
                    process data from users under this age limit.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>3. User Accounts</h3>
                <p>
                    To access certain features of the Platform, you may be
                    required to create an account. You agree to provide accurate
                    and complete information when registering, and to keep this
                    information up to date.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>
                    4. Use of the Platform
                </h3>
                <ul className='list-disc list-inside'>
                    <li>
                        Only use the Platform for lawful purposes, in compliance
                        with all applicable laws and regulations.
                    </li>
                    <li>
                        Refrain from uploading, posting, or sharing any content
                        that is illegal, offensive, or defamatory.
                    </li>
                    <li>Avoid impersonating other individuals or entities.</li>
                </ul>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>5. Content</h3>
                <p>
                    By uploading content, you grant PLAYERAPP LTD a
                    non-exclusive, worldwide, royalty-free license to use,
                    modify, and distribute your content.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>
                    6. Communication with Users
                </h3>
                <p>
                    By providing your contact information, you agree that
                    PLAYERAPP LTD may contact you via email, phone, or other
                    methods.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>7. Data Privacy</h3>
                <p>
                    Your privacy is important to us. For details, refer to our
                    Privacy Policy.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>
                    8. Intellectual Property
                </h3>
                <p>
                    All content and materials available on the Platform are the
                    property of PLAYERAPP LTD or its licensors, and are
                    protected by intellectual property laws.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>
                    9. Limitation of Liability
                </h3>
                <p>
                    The Platform is provided "as is" and "as available."
                    PLAYERAPP LTD will not be liable for any indirect,
                    incidental, or consequential damages.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>10. User Conduct</h3>
                <p>
                    By using the Platform, you agree not to upload or share
                    objectionable content, engage in harassment, or disrupt the
                    operation of the Platform.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>
                    11. Recruitment and Scouting
                </h3>
                <p>
                    The Platform may facilitate recruitment or scouting
                    opportunities, but PLAYERAPP LTD does not guarantee any
                    specific outcomes.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>
                    12. Third-Party Links and Services
                </h3>
                <p>
                    The Platform may contain links to third-party websites or
                    services, which you access at your own risk.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>13. Termination</h3>
                <p>
                    You may terminate your account at any time by contacting us.
                    We reserve the right to suspend or terminate your account at
                    our discretion.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>
                    14. Modifications to the Platform and Terms
                </h3>
                <p>
                    PLAYERAPP LTD reserves the right to modify the Platform or
                    change these Terms and Conditions at any time without prior
                    notice.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>15. Governing Law</h3>
                <p>
                    These Terms and Conditions are governed by the laws of
                    England and Wales. Disputes will be resolved in the courts
                    of England and Wales.
                </p>
            </section>

            <section className='mb-6'>
                <h3 className='text-xl font-semibold'>16. Contact Us</h3>
                <p>
                    If you have any questions or concerns, please contact us at:
                </p>
                <p>Email: hello@playerapp.co</p>
                <p>
                    Address: 4th Floor Charles House, 108-110 Finchley Road,
                    London, NW3 5JJ
                </p>
            </section>
        </div>
    );
};

export default TermsAndConditions;
